import { EgroupsState } from "../store/egroups/types";
import { EteamsState } from "../store/eteams/types";
import { SalvationsState } from "../store/salvations/types";
import { BaptismsState } from "../store/baptisms/types";
import { WatchPartyState } from "../store/watchParty/types";
import { EventState } from "../store/events/types";
import { MainState } from "../store/main/types";
import { actions as MainActions } from "../store/main";
import { actions as eGroupActions } from "../store/egroups";
import { actions as BaptismsActions } from "../store/baptisms";
import { actions as EteamsActions } from "../store/eteams";
import { actions as SalvationsActions } from "../store/salvations";
import { actions as WatchPartyActions } from "../store/watchParty";
import { actions as EventsActions } from "../store/events";
import { NextRouter } from "next/router";

// The types of the props that contains the Redux components (actions and reducers)
export interface ConnectionCenterProps {
    actions: {
        main: typeof MainActions;
        eGroups: typeof eGroupActions;
        baptisms: typeof BaptismsActions;
        eTeams: typeof EteamsActions;
        salvations: typeof SalvationsActions;
        watchParties: typeof WatchPartyActions;
        events: typeof EventsActions;
    };
    main: MainState;
    eGroups: EgroupsState;
    eTeams: EteamsState;
    baptism: BaptismsState;
    salvations: SalvationsState;
    watchParties: WatchPartyState;
    registrationType: registrationType;
    events: EventState;
}

export enum registrationType {
    eTeam = "eTeam",
    eLeader = "eLeader",
    Baptism = "Baptism",
    Salvation = "Salvation",
    eGroup = "eGroup",
    watchParty = "watch-party",
    egroupCurriculum = "egroup-curriculum",
    event = "event",
}

export type eGroupRouteProps = {
    selectedCampusSlug: string;
    url: string;
};

// Types to handle the props when the route doesn't have params
export interface Props extends ConnectionCenterProps {
    router: NextRouter;
}
